import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { FieldLines } from './FieldLines';
const chips = ['6 Volumes', '5 Bonuses', '121 Fence Card Sessions', '5 event groups', 'Youth · MS · HS', '60 · 75 · 90 min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or read it on your phone'];

/** Athletes as they appear in the volume diagrams: a dot in the group colour, and the circled C for the coach. */
const tokens = [{
  cls: 'bg-clay',
  letter: ''
}, {
  cls: 'bg-amber',
  letter: ''
}, {
  cls: 'bg-infield',
  letter: ''
}, {
  cls: 'bg-lane',
  letter: ''
}, {
  cls: 'bg-hl text-hl-ink',
  letter: 'C'
}];
export function Hero() {
  return <section className="track-night relative w-full overflow-hidden" data-id="element-192" data-mp="nboo33emcq2x">
      <FieldLines className="absolute -right-64 top-[440px] h-[680px] w-[680px] sm:-right-32 sm:top-[360px] lg:-right-60 lg:top-[-20px] lg:h-[900px] lg:w-[900px] lg:opacity-80" data-id="element-193" data-mp="3d1sayygxbltn" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-194" data-mp="3j8sfe0v2xjpu">
        <div className="grid gap-7 lg:grid-cols-[1.08fr_.92fr] lg:items-center lg:gap-x-10 lg:gap-y-6" data-id="element-195" data-mp="3o858h3cjnn0v">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-196" data-mp="39b4gcyqfxq1v">
            <p className="inline-flex items-center gap-2 rounded-full border border-chalk/15 bg-chalk/5 px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.2px] text-chalk/80 sm:text-[11px] sm:tracking-[1.6px]" data-id="element-197" data-mp="39cpbapgo3b09">
              <span className="h-2 w-2 flex-none rounded-full bg-clay" aria-hidden="true" data-id="element-198" data-mp="358hmyte4fx2k" />
              Track Coach Ready · school &amp; club track coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] leading-[1.04] text-chalk sm:text-[54px] lg:text-[54px] xl:text-[60px]" data-id="element-199" data-mp="2qhqwpps6h61k">
              Handed events you&apos;ve never coached?{' '}
              <br className="hidden sm:block" data-id="element-200" data-mp="2hl9sz7m58afu" />
              <span className="mark-stroke text-chalk" data-id="element-201" data-mp="2lla8ywow4tp0">Every practice is already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-202" data-mp="s2tb5evynxmk">
            <p className="max-w-xl text-[15px] leading-relaxed text-chalk/80 sm:text-base lg:text-lg" data-id="element-203" data-mp="nbl1chqpya8v">
              121 ready-to-run practices for sprints, hurdles, jumps, throws and
              distance. Every practice is a printable Fence Card for each event
              group, with reps, rest, cues and safety rules already written, in
              60, 75 and 90-minute versions. Print it, post it on the fence, run
              practice.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-204" data-mp="15zq1lf863d2x">
              <CtaButton data-id="element-205" data-mp="111omt6hrxzx9">Get Track Coach Ready</CtaButton>
            </div>
          </div>

          <div className="-mx-2 sm:mx-auto sm:w-full sm:max-w-[560px] lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:max-w-none lg:self-center" data-id="element-206" data-mp="x1wbim0zxfo7">
            <ProductVisual data-id="element-207" data-mp="3lqug7stmcf76" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-208" data-mp="3hr3sxz3awh7e">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-209" data-mp="3htpzpwidasok">
              <ul className="flex -space-x-2" aria-hidden="true" data-id="element-210" data-mp="1x783jjm4pjs0">
                {tokens.map((t, i) => <li key={i} data-id="element-211" data-mp="218jwnz47on4y" data-mpi={i}>
                    <span className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-navy-deep font-display text-sm font-bold shadow-[inset_0_-3px_6px_rgba(0,0,0,0.3)] sm:h-10 sm:w-10 ${t.cls}`} data-id="element-212" data-mp="269hegalb7f5x">
                      {t.letter}
                    </span>
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-chalk/70" data-id="element-213" data-mp="2p0h6xls0j73y">
                Written for the <span className="font-semibold text-chalk" data-id="element-214" data-mp="2oynwdvea42qo">head coaches, assistants &amp; first-year coaches</span>{' '}
                running youth, middle school and high school track.
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-chalk/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-215" data-mp="zl0yk8lwxpf4">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-216" data-mp="49t1vp3yyoq8">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-hl" data-id="element-217" data-mp="3vigpkbpomo0y" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-218" data-mp="9ah291e38hx4">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-219" data-mp="9b0afqdxrrxy">
              {chips.map(chip => <li key={chip} className="rounded-full border border-chalk/15 bg-navy-deep/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-chalk/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-220" data-mp="3hqshcjik0jp9">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}